export default __webpack_public_path__ + "static/media/1663.eaba38aa.png";